window.addEventListener('load', function () {
    if (document.querySelectorAll('.glossary .filter').length) {
        const elements = document.querySelectorAll('.glossary .filter');

        elements.forEach(function (element) {
            const buttons = element.querySelectorAll('button');
            const select = element.querySelector('select');
            const nonce = element.getAttribute('data-nonce');
            const entriesWrap = element.nextElementSibling;

            function resetClasses () {
                buttons.forEach(e => e.classList.remove('active'));
            }

            if (buttons.length) {
                buttons.forEach(function (button) {
                    if (!button.classList.contains('disabled')) {
                        button.addEventListener('click', function (event) {
                            const index = [...button.parentNode.children].indexOf(button);

                            resetClasses();

                            button.classList.add('active');
                            select.selectedIndex = index;

                            const letter = button.getAttribute('data-letter');
                            loadGlossary(letter, nonce, entriesWrap);
                        });
                    }
                });
            }

            if (select.length) {
                select.addEventListener('change', function (event) {
                    resetClasses();

                    buttons[this.selectedIndex].classList.add('active');

                    const value = this.options[this.selectedIndex].value;
                    loadGlossary(value, nonce, entriesWrap);
                });
            }
        });

        // ajax load function to be triggered by button and select
        function loadGlossary (letter, nonce, entriesWrap) {

            entriesWrap.classList.add('loading');

            gsap.to(entriesWrap.querySelectorAll('.entry'), {autoAlpha: 0, y: 20});

            // make ajax call with letter to '/wp-admin/admin-ajax.php', action 'load_glossary'
            // on success, replace the content of the glossary with the json response

            var request = new XMLHttpRequest();

            request.open('POST', '/wp-admin/admin-ajax.php', true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    // If successful
                    const response = JSON.parse(this.response);
                    entriesWrap.innerHTML = response;
                    entriesWrap.classList.remove('loading');
                    gsap.from(entriesWrap.querySelectorAll('.entry'), {autoAlpha: 0, y: 20, onComplete:function(){
                        this.targets().forEach(function (target) {
                            target.classList.remove('hidden');
                        });
                    }});
                } else {
                    // If fail
                }
            };
            request.onerror = function() {
                // Connection error
            };
            request.send('action=load_glossary&nonce=' + nonce + '&letter=' + letter);

        }
    }
});
